(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tabSection = document.getElementById('cpv2-product-tabs');
    if (!tabSection) return;

    var tabBtns        = tabSection.querySelectorAll('.cpv2-tab-btn');
    var tabPanels      = tabSection.querySelectorAll('.cpv2-tab-panel');
    var accordionBtns  = tabSection.querySelectorAll('.cpv2-accordion-heading');
    var MOBILE_BREAK   = window.matchMedia('(max-width: 749px)');

    // ── Core: open a tab by key — works for both modes ────────────────────
    function openTab(key) {
      if (MOBILE_BREAK.matches) {
        // Mobile: accordion mode
        accordionBtns.forEach(function (btn) {
          var panel    = btn.closest('.cpv2-tab-panel');
          var isTarget = panel.dataset.tabKey === key;
          btn.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
          btn.nextElementSibling.classList.toggle('is-open', isTarget);
        });
      } else {
        // Desktop: tab mode
        tabBtns.forEach(function (btn) {
          var active = btn.dataset.tab === key;
          btn.classList.toggle('active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        tabPanels.forEach(function (panel) {
          panel.classList.toggle('active', panel.dataset.tabKey === key);
        });
      }
      // Trigger Judge.me re-render when reviews panel becomes visible
      if (key === 'reviews') {
        setTimeout(function () {
          if (window.jdgm && typeof window.jdgm.loadAll === 'function') {
            window.jdgm.loadAll();
          }
        }, 100);
      }
    }

    // ── Desktop tab button clicks ─────────────────────────────────────────
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openTab(btn.dataset.tab);
      });
    });

    // ── Mobile accordion heading clicks ───────────────────────────────────
    accordionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel    = btn.closest('.cpv2-tab-panel');
        var isOpen   = btn.getAttribute('aria-expanded') === 'true';
        var key      = panel.dataset.tabKey;
        // Close all, then open if it was closed
        accordionBtns.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          b.nextElementSibling.classList.remove('is-open');
        });
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          btn.nextElementSibling.classList.add('is-open');
        }
      });
    });

    // ── Anchor nav links (from custom-product-v2) ─────────────────────────
    document.querySelectorAll('.cpv2-anchor-link[data-tab-open]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        openTab(link.dataset.tabOpen);
        tabSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // ── Judge.me preview badge click (rating stars in buy box) ─────────────
    // Judge.me's badge has its own click handler that scrolls to the widget.
    // We must intercept BEFORE Judge.me — use capturing phase (3rd arg true)
    // so our handler fires top-down before the badge's own listener.
    document.addEventListener('click', function (e) {
      var badge = e.target.closest('.cpv2-reviews .jdgm-preview-badge, .cpv2-reviews .jdgm-prev-badge');
      if (!badge) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openTab('reviews');
      tabSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, true);

    // ── FAQ accordion ─────────────────────────────────────────────────────
    tabSection.querySelectorAll('.cpv2-faq-question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var answer   = btn.nextElementSibling;
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        answer.hidden = expanded;
      });
    });

    // ── Initial state ─────────────────────────────────────────────────────
    // On mobile: open first accordion by default.
    // On desktop: first panel is already .active from HTML.
    if (MOBILE_BREAK.matches) {
      var firstAccBtn = tabSection.querySelector('.cpv2-accordion-heading');
      if (firstAccBtn) {
        firstAccBtn.setAttribute('aria-expanded', 'true');
        firstAccBtn.nextElementSibling.classList.add('is-open');
      }
    }

    // Handle URL hash on page load
    var hashMap = {
      '#cpv2-description': 'description',
      '#cpv2-reviews':     'reviews',
      '#cpv2-faq':         'faq'
    };
    var initialTab = hashMap[window.location.hash];
    if (initialTab) {
      openTab(initialTab);
      tabSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-v2"] && !Shopify.designMode) return;
  try {
    
  // Sync quantity section visibility with add-to-cart button state
  // This runs immediately and also sets up a polling fallback for initial load
  (function() {
    var quantitySection = document.querySelector('.cpv2-quantity-section[ref="quantitySection"]');
    var addToCartBtn = document.querySelector('.cpv2-btn-addtocart');
    var qtyInput = document.querySelector('.cpv2-qty-input');
    var qtyBtns = document.querySelectorAll('.cpv2-qty-btn');

    function syncQtyVisibility() {
      if (!quantitySection || !addToCartBtn) return;

      var isDisabled = addToCartBtn.disabled;
      if (isDisabled) {
        quantitySection.classList.add('is-hidden');
        // Also disable +/- buttons and input to prevent any interaction
        if (qtyInput) qtyInput.disabled = true;
        qtyBtns.forEach(function(btn) { btn.disabled = true; });
      } else {
        quantitySection.classList.remove('is-hidden');
        if (qtyInput) qtyInput.disabled = false;
        qtyBtns.forEach(function(btn) { btn.disabled = false; });
      }
    }

    // Poll for the first 3 seconds to catch the initial disabled state during page load
    var pollCount = 0;
    var pollInterval = setInterval(function() {
      syncQtyVisibility();
      pollCount++;
      if (pollCount >= 30) clearInterval(pollInterval); // stop after 3s
    }, 100);

    // MutationObserver as a live fallback for subsequent variant changes
    if (addToCartBtn) {
      var qtyObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'disabled') {
            syncQtyVisibility();
          }
        });
      });
      qtyObserver.observe(addToCartBtn, { attributes: true, attributeFilter: ['disabled'] });
    }

    // Quantity selector +/- buttons functionality
    var qtyWarning = document.querySelector('.cpv2-qty-warning');

    function updateQtyWarning(val, min, max) {
      if (!qtyWarning) return;
      qtyWarning.hidden = !(val >= max);
    }

    qtyBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (addToCartBtn && addToCartBtn.disabled) return;

        var action = btn.dataset.action;
        var currentVal = parseInt(qtyInput.value) || 1;
        var min = parseInt(qtyInput.min) || 1;
        var max = parseInt(qtyInput.max) || 999;
        var step = parseInt(qtyInput.step) || 1;

        var newVal;
        if (action === 'decrease') {
          newVal = Math.max(min, currentVal - step);
        } else {
          newVal = Math.min(max, currentVal + step);
        }
        qtyInput.value = newVal;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        updateQtyWarning(newVal, min, max);
      });
    });

    // Also handle manual input
    if (qtyInput) {
      qtyInput.addEventListener('change', function() {
        var min = parseInt(qtyInput.min) || 1;
        var max = parseInt(qtyInput.max) || 999;
        var val = parseInt(qtyInput.value) || min;
        updateQtyWarning(val, min, max);
      });
    }

    // Select-mode variant picker: sync <select> → hidden radio inputs
    var variantSelects = document.querySelectorAll('.cpv2-variant-select');
    variantSelects.forEach(function(select) {
      select.addEventListener('change', function() {
        var fieldsetIndex = select.dataset.fieldsetIndex;
        var selectedValue = select.value;
        var fieldset = document.querySelector('.cpv2-hidden-radios[data-fieldset-index="' + fieldsetIndex + '"]');
        if (!fieldset) return;
        var radios = fieldset.querySelectorAll('input[type="radio"]');
        radios.forEach(function(radio) {
          if (radio.value === selectedValue && !radio.checked) {
            radio.click();
          }
        });
      });
    });

    // Media carousel functionality
    var carouselItems = document.querySelectorAll('.cpv2-carousel-item');
    var mainMedia = document.querySelector('.cpv2-main-media img');

    carouselItems.forEach(function(item) {
      item.addEventListener('click', function() {
        var mediaId = item.dataset.mediaId;
        var newSrc = item.querySelector('img').src.replace('width=100', 'width=600');

        carouselItems.forEach(function(ci) { ci.classList.remove('active'); });
        item.classList.add('active');

        if (mainMedia) {
          mainMedia.style.opacity = '0';
          setTimeout(function() {
            mainMedia.src = newSrc;
            mainMedia.style.opacity = '1';
          }, 200);
        }
      });
    });

    // Variant change — update quantity max based on inventory minus cart quantity
    (function() {
      var inventoryEl = document.getElementById('cpv2-variant-inventory');
      if (!inventoryEl) return;
      var inventoryData = {};
      try { inventoryData = JSON.parse(inventoryEl.textContent); } catch(e) {}

      function updateQtyMax(variantId) {
        var data = inventoryData[variantId];
        if (!data) return;
        if (!qtyInput) return;

        var newMax     = data.remaining;
        var currentVal = parseInt(qtyInput.value) || data.min;

        qtyInput.max  = newMax;
        qtyInput.min  = data.min;
        qtyInput.step = data.step;

        // Clamp value to new max
        if (currentVal > newMax) {
          qtyInput.value = Math.max(data.min, newMax);
        }

        updateQtyWarning(parseInt(qtyInput.value), data.min, newMax);
      }

      document.addEventListener('variant:update', function(e) {
        var id = e.detail && e.detail.resource && e.detail.resource.id;
        if (id) updateQtyMax(String(id));
      });
      document.addEventListener('variant:selected', function(e) {
        var id = e.detail && e.detail.resource && e.detail.resource.id;
        if (id) updateQtyMax(String(id));
      });
    })();

    // What You Get — switch between digital/physical list on variant change
    (function() {
      var variantTypesEl = document.getElementById('cpv2-variant-types');
      if (!variantTypesEl) return;
      var variantTypes = {};
      try { variantTypes = JSON.parse(variantTypesEl.textContent); } catch(e) {}

      function updateWYG(variantId) {
        var data = variantTypes[variantId];
        if (!data) return;
        var line2      = document.querySelector('[data-wyg-line2]');
        var variantName = document.querySelector('[data-wyg-variant-name]');
        var isPhysical  = data.type === 'physical';

        if (!line2) return;
        if (isPhysical) {
          // Physical: show shipping line with variant name
          line2.innerHTML = 'Schneller Versand Ihres <strong data-wyg-variant-name>' + data.title + '</strong>';
        } else {
          // Digital: show download line
          line2.textContent = 'Bereitstellung der Original-Software als sofortiger Download';
        }
      }

      // Listen to theme's variant update event
      document.addEventListener('variant:update', function(e) {
        var id = e.detail && e.detail.resource && e.detail.resource.id;
        if (id) updateWYG(String(id));
      });

      // Also listen to variant:selected for immediate feedback
      document.addEventListener('variant:selected', function(e) {
        var id = e.detail && e.detail.resource && e.detail.resource.id;
        if (id) updateWYG(String(id));
      });
    })();

    // Stock availability update on variant change
    // Uses pre-computed per-variant map from Liquid (authoritative source)
    (function() {
      var stockSettingsEl = document.getElementById('cpv2-stock-settings');
      var stockMapEl      = document.getElementById('cpv2-variant-stock-map');
      if (!stockSettingsEl || !stockMapEl) return;

      var stockSettings = {};
      var stockMap      = {};
      try { stockSettings = JSON.parse(stockSettingsEl.textContent); } catch(e) { return; }
      try { stockMap      = JSON.parse(stockMapEl.textContent); }      catch(e) { return; }

      var greenText     = stockSettings.greenText     || 'Auf Lager';
      var lowText       = stockSettings.lowText       || 'Nur noch';
      var availableText = stockSettings.availableText || 'verfügbar';
      var urgentText    = stockSettings.urgentText    || 'schnell bestellen!';

      function updateStock(variantId) {
        var stockEl = document.querySelector('.cpv2-stock-availability');
        if (!stockEl) return;

        var data = stockMap[String(variantId)];
        if (!data) return;

        var status = data.status;
        var qty    = data.qty;

        stockEl.hidden = false;
        stockEl.className = 'cpv2-stock-availability cpv2-stock-availability--' + status;

        var textEl = stockEl.querySelector('.cpv2-stock-text');
        if (!textEl) return;

        if (status === 'unavailable') {
          textEl.textContent = 'Ausverkauft';
        } else if (status === 'green') {
          textEl.textContent = greenText;
        } else {
          var urgentHtml = status === 'red'
            ? ' \u2013 <span class="cpv2-stock-urgent">' + urgentText + '</span>'
            : '';
          textEl.innerHTML = lowText + ' ' + qty + ' ' + availableText + urgentHtml;
        }
      }

      document.addEventListener('variant:update', function(e) {
        var id = e.detail && e.detail.resource && e.detail.resource.id;
        if (id) updateStock(id);
      });
      document.addEventListener('variant:selected', function(e) {
        var id = e.detail && e.detail.resource && e.detail.resource.id;
        if (id) updateStock(id);
      });
    })();

    // Price update on variant change
    // Re-reads price data from the DOM each time so it works with dynamically
    // injected content (quick-add modal, section re-renders).
    (function() {
      function getPriceData() {
        var el = document.getElementById('cpv2-variant-prices');
        if (!el) return null;
        try { return JSON.parse(el.textContent); } catch(e) { return null; }
      }

      function updatePrice(variantId) {
        var priceData = getPriceData();
        if (!priceData) return;
        var data = priceData[String(variantId)];
        if (!data) return;

        var wrapper = document.querySelector('[data-cpv2-price-wrapper]');
        var compareEl = document.querySelector('[data-cpv2-compare-price]');
        var currentEl = document.querySelector('[data-cpv2-current-text]');
        if (!wrapper || !currentEl) return;

        // Update current price text
        currentEl.textContent = data.price + ' ' + data.currency_symbol + ' *';

        // Handle compare-at price (show/hide)
        if (data.compare_at_price && data.available) {
          if (compareEl) {
            // Update existing compare price text
            var compareText = compareEl.querySelector('[data-cpv2-compare-text]');
            if (compareText) compareText.textContent = data.compare_at_price + ' ' + data.currency_symbol + ' *';
            compareEl.hidden = false;
          } else {
            // Create compare price element
            var newCompare = document.createElement('span');
            newCompare.className = 'cpv2-price-compare';
            newCompare.setAttribute('data-cpv2-compare-price', '');
            var newCompareText = document.createElement('span');
            newCompareText.className = 'cpv2-price-compare__text';
            newCompareText.setAttribute('data-cpv2-compare-text', '');
            newCompareText.textContent = data.compare_at_price + ' ' + data.currency_symbol + ' *';
            newCompare.appendChild(newCompareText);
            wrapper.insertBefore(newCompare, wrapper.firstChild);
          }
        } else {
          if (compareEl) {
            compareEl.hidden = true;
          }
        }
      }

      document.addEventListener('variant:update', function(e) {
        var id = e.detail && e.detail.resource && e.detail.resource.id;
        if (id) updatePrice(String(id));
      });
      document.addEventListener('variant:selected', function(e) {
        var id = e.detail && e.detail.resource && e.detail.resource.id;
        if (id) updatePrice(String(id));
      });
    })();

    // Anchor nav: first item active by default, pointer/click/focus updates active item
    (function() {
      var links = Array.prototype.slice.call(document.querySelectorAll('.cpv2-anchor-link'));
      if (!links.length) return;

      function setActive(link) {
        if (!link || link.classList.contains('cpv2-anchor-link--active')) return;
        links.forEach(function(item) {
          item.classList.remove('cpv2-anchor-link--active');
          item.removeAttribute('aria-current');
        });
        link.classList.add('cpv2-anchor-link--active');
        link.setAttribute('aria-current', 'true');
      }

      links[0].classList.add('cpv2-anchor-link--active');
      links[0].setAttribute('aria-current', 'true');

      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      links.forEach(function(link) {
        if (canHover) {
          link.addEventListener('mouseenter', function() {
            setActive(link);
          });
        }
        link.addEventListener('click', function() {
          setActive(link);
        });
        link.addEventListener('focus', function() {
          setActive(link);
        });
      });
    })();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
